import { Table, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import { styled } from 'troyfe';
import { arrayToTree } from '@/utils';
import Pagination from './pagination';
import { AdminRoleTemplateApi } from 'gmrfid-service-user-api-manager';

const Block = styled.div`
  .ant-table-thead > tr > th {
    text-align: center;
    padding: 5px 16px;
  }

  .ant-table-tbody > tr > td {
    text-align: center;
  }

  .ant-spin-dot-item {
    background: #44bb55;
  }

  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 8px 8px;
  }

  // .ant-table.ant-table-small .ant-table-tbody > tr > td {
  //   padding: 13px 8px;
  // }

  // .ant-table.ant-table-small .ant-table-thead > tr > th {
  //   padding: 10px 8px;
  //   color: #1b1b1d;
  // }

  .ant-pagination-item-active a {
    color: #fff;
  }

  .ant-pagination-item-active {
    border-color: #44bb55;
    background: #44bb55;
  }

  .ant-table-selection-column {
    width: 2%;
  }
`;

/**
 *
 * @param {{
 * url: String,
 * tableTime: Number,
 * fields: Number
 * method: String
 * }} props {
 * url: 请求地址,
 * tableTime: 用于更新列表 (参数是一个随机数),
 * fields: 请求参数
 * }
 * @returns
 */

const TableAssembly = (props) => {
  const {
    tableTime,
    fields,
    queryTableList,
    parameterName,
    tableTree,
    setTableTotal,
    setTableData,
    secondaryRequest = false, // 子项请求
    queryAllType = false, // 是否请求所有,
    chargeOrderRequest = false,
    oftenStayUserCountRequest = false,
    check,
    getCheck,
    paginationProps = {
      size: 'medium',
    },
  } = props;
  const [sourceData, setSourceData] = useState([]);
  const [size, setSize] = useState(props?.customSize || 10);
  const [current, setCurrent] = useState(1);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState();
  useEffect(() => {
    setCurrent(1);
    setSize(props?.customSize || 10);
    setTotal(0);
    setRefresh(Math.random());
  }, [fields]);

  useEffect(() => {
    if (queryTableList && refresh) {
      try {
        let par = {};
        if (queryAllType) {
          par = fields;
        } else {
          par = { ...fields, page: current - 1, pageSize: size };
        }
        queryTableList({
          [parameterName]: par,
        }).then((res) => {
          if (res && res.status === 200) {
            setLoading(false);
            setTotal(res.data.totalElements);
            if (tableTree) {
              setSourceData(arrayToTree(res.data.content, 'id', 'parentId'));
            } else {
              const data = res.data.content || res.data;
              const newData = data.map((item) => {
                const obj = {
                  ...item,
                };
                if (item.startTime && item.startTime.length > 22) {
                  obj.startTime = item.startTime.slice(0, -4);
                }
                if (item.endTime && item.endTime.length > 22) {
                  obj.endTime = item.endTime.slice(0, -4);
                }
                if (item.createDate && item.createDate.length > 22) {
                  obj.createDate = item.createDate.slice(0, -4);
                }
                if (item.markTime && item.markTime.length > 22) {
                  obj.markTime = item.markTime.slice(0, -4);
                }
                return obj;
              });
              /* 套餐 */
              if (props?.combo) {
                return Promise.all(
                  res.data.content.map((item) =>
                    AdminRoleTemplateApi.roleTemplateInfo({
                      form: {
                        id: item.id,
                      },
                    }).then((status) => {
                      return {
                        ...item,
                        comboObj: status?.data || {},
                      };
                    })),
                ).then((all) => {
                  setSourceData(all);
                });
              }
              setSourceData(newData);
              setTableData && setTableData(newData);
            }
            setTotal(res.data.totalElements);
            setTableTotal && setTableTotal(res.data.totalElements);
          }
        });
      } catch (err) {
        console.log(err);
      }
    } else {
      setLoading(false);
    }
  }, [tableTime, current, size, queryTableList, refresh]);

  const tableProps = {
    loading,
    pagination: false,
    scroll: props.scroll,
    ...props,
    columns:
      props.columns &&
      props.columns.map((item) => {
        if (item.dataIndex === 'num') {
          return {
            ...item,
            render: (text, record, index) => (current - 1) * size + (index + 1),
          };
        }
        if ((item.dataIndex === 'name' && item.isShowTitle) || item.isShowTitle) {
          return {
            ...item,
            ellipsis: {
              showTitle: false,
            },
            render: (address) => (
              <Tooltip placement="bottomLeft" title={<span style={{ color: 'black' }}>{address}</span>} color="#fff">
                {address && address.length > 30 ? `${address.slice(0, 30)}...` : address}
              </Tooltip>
            ),
          };
        }

        return item;
      }),
  };

  const pageProps = {
    total,
    current,
    pageSize: size,
    onChange: (page, pageSize) => {
      setSize(pageSize);
      setCurrent(page);
    },
  };

  const checkObj = check
    ? {
      rowSelection: {
        type: 'checkbox',
        onChange: (selectedRowKeys, selectedRows) => {
          getCheck(selectedRows.map((v) => v.id));
        },
        getCheckboxProps: (record) => ({
          disabled: !record.checked,
          name: record.name,
        }),
      },
    } : {};

  return (
    <Block>
      <Table
        {...tableProps}
        {...checkObj}
        dataSource={props.filterFn ? props.filterFn(sourceData) : sourceData}
        rowKey={(record) => record.id}
        locale={{ emptyText: props.localeText || '亲,目前没有数据哟~' }}
      />
      {props.newPagination && <Pagination {...paginationProps} {...pageProps} style={{ marginTop: '20px' }} />}
    </Block>
  );
};

export default TableAssembly;
